<form [formGroup]="successStoryForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6 p-6">
  <!-- Cover Image Field -->
  <div class="flex flex-col gap-2">
    <label class="text-label-md">{{ 'successStories.coverImage' | translate }}</label>

    @if (previewImageUrl) {
    <div class="relative inline-block">
      <img [src]="previewImageUrl" [alt]="'successStories.imagePreview' | translate"
        class="w-full max-w-sm h-48 object-cover rounded border border-gray-600" />
      <p-button type="button" icon="pi pi-times" [rounded]="true" size="small" (onClick)="removeImage()"
        class="absolute top-2 right-2" [ariaLabel]="'successStories.removeImage' | translate">
      </p-button>
    </div>
    } @else {
    <p-fileUpload mode="basic" [chooseLabel]="'successStories.chooseImage' | translate" accept="image/*"
      [maxFileSize]="10000000" [auto]="true" (onSelect)="onImageSelect($event)" class="w-full"></p-fileUpload>
    }
  </div>

  <!-- Title Field -->
  <div class="flex flex-col gap-2">
    <div class="flex justify-between items-center">
      <label for="title" class="text-label-md">{{ 'successStories.storyTitle' | translate }}</label>
      <span class="text-caption-sm text-secondary">
        {{ titleControl.value?.length || 0 }} / 200
      </span>
    </div>
    <input id="title" type="text" pInputText [formControl]="titleControl"
      [placeholder]="'successStories.titlePlaceholder' | translate" class="w-full" maxlength="200" />
    @if (titleControl.invalid && titleControl.touched) {
    <p-message severity="error">
      {{ getTitleErrorMessage() }}
    </p-message>
    }
  </div>

  <!-- Description Field -->
  <div class="flex flex-col gap-2">
    <div class="flex justify-between items-center">
      <label for="description" class="text-label-md">{{ 'successStories.description' | translate }}</label>
      <span class="text-caption-sm text-secondary">
        {{ descriptionControl.value?.length || 0 }} / 1000
      </span>
    </div>
    <textarea id="description" [formControl]="descriptionControl"
      [placeholder]="'successStories.descriptionPlaceholder' | translate" rows="4"
      class="w-full p-3 border border-gray-600 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-700 text-white"
      maxlength="1000"></textarea>
    @if (descriptionControl.invalid && descriptionControl.touched) {
    <p-message severity="error">
      {{ getDescriptionErrorMessage() }}
    </p-message>
    }
  </div>

  <!-- Link URL Field -->
  <div class="flex flex-col gap-2">
    <label for="linkUrl" class="text-label-md">{{ 'successStories.linkUrl' | translate }}</label>
    <input id="linkUrl" type="url" pInputText [formControl]="linkUrlControl"
      [placeholder]="'successStories.linkUrlPlaceholder' | translate" class="w-full" />
    @if (linkUrlControl.invalid && linkUrlControl.touched) {
    <p-message severity="error">
      {{ getLinkUrlErrorMessage() }}
    </p-message>
    }
  </div>

  <!-- Action Buttons -->
  <div class="flex flex-row gap-4 mt-6">
    <p-button type="submit" [label]="submitting()
        ? (isEdit ? ('successStories.updating' | translate) : ('successStories.adding' | translate))
        : (isEdit ? ('successStories.updateStory' | translate) : ('successStories.addStory' | translate))"
      [icon]="submitting() ? 'pi pi-spin pi-spinner' : (isEdit ? 'pi pi-save' : 'pi pi-plus')"
      [disabled]="successStoryForm.invalid || submitting()" [loading]="submitting()" />

    <p-button type="button" [label]="'successStories.cancel' | translate" severity="secondary" [outlined]="true"
      [disabled]="submitting()" (onClick)="onCancel()" />
  </div>
</form>
